var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$ml.list.length > 1)?_c('div',_vm._l((_vm.$ml.list),function(lang){return _c('img',{key:lang,staticClass:"flag",attrs:{"src":'/resources/flag_' + lang + '.svg'},on:{"click":function () {
        _vm.$ml.change(lang);
      }}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }